import React from "react";
import MultiAccordion from "../Accordion/multiAccordion";

export default function ProductFaq({ data }: any) {
  return (
    <div className="landing-animation-info-component">
      <div
        className="video-title"
        dangerouslySetInnerHTML={{ __html: data.title }}
      />
      <div className="hide-animation-tablet">
        <MultiAccordion data={data?.Benifits} videoAnim={true} itemLabel="Label" itemValue="Value" />;
      </div>
    </div>
  );
}
